import React from 'react';
import './Security.css';

const Security = () => {
  return (
    <div className="security-page">
      {/* Hero Section */}
      <div className="security-hero">
        <div className="security-hero-content">
          <h1>Security</h1>
          <p>Protecting your data and ensuring secure transactions</p>
        </div>
      </div>

      <div className="security-container">
        <div className="security-content">
          <div className="security-section">
            <h2>Our Security Commitment</h2>
            <p>At Inifiy, we take your security seriously. We implement industry-standard security measures to protect your personal information and ensure secure transactions.</p>
          </div>

          <div className="security-section">
            <h2>Data Protection</h2>
            <div className="security-features">
              <div className="security-feature">
                <div className="feature-icon">🔒</div>
                <h3>Encryption</h3>
                <p>All sensitive data is encrypted using SSL/TLS technology to ensure secure transmission between your browser and our servers.</p>
              </div>
              <div className="security-feature">
                <div className="feature-icon">🛡️</div>
                <h3>Secure Storage</h3>
                <p>Your personal information is stored securely using advanced encryption and access controls to prevent unauthorized access.</p>
              </div>
              <div className="security-feature">
                <div className="feature-icon">🔐</div>
                <h3>Access Controls</h3>
                <p>We implement strict access controls and authentication measures to ensure only authorized personnel can access your data.</p>
              </div>
            </div>
          </div>

          <div className="security-section">
            <h2>Payment Security</h2>
            <div className="payment-security">
              <div className="payment-card">
                <h3>PCI DSS Compliance</h3>
                <p>We are fully compliant with Payment Card Industry Data Security Standard (PCI DSS) to ensure secure payment processing.</p>
              </div>
              <div className="payment-card">
                <h3>Secure Payment Gateways</h3>
                <p>We use trusted payment processors that implement the highest security standards for handling your payment information.</p>
              </div>
              <div className="payment-card">
                <h3>Fraud Protection</h3>
                <p>Advanced fraud detection systems monitor transactions to identify and prevent fraudulent activities.</p>
              </div>
            </div>
          </div>

          <div className="security-section">
            <h2>Website Security</h2>
            <div className="website-security">
              <div className="security-measure">
                <h3>HTTPS Encryption</h3>
                <p>Our website uses HTTPS encryption to secure all communications between your browser and our servers.</p>
              </div>
              <div className="security-measure">
                <h3>Regular Security Audits</h3>
                <p>We conduct regular security audits and vulnerability assessments to identify and address potential security risks.</p>
              </div>
              <div className="security-measure">
                <h3>Firewall Protection</h3>
                <p>Advanced firewall systems protect our servers from unauthorized access and malicious attacks.</p>
              </div>
              <div className="security-measure">
                <h3>DDoS Protection</h3>
                <p>We implement DDoS protection measures to ensure our services remain available during potential attacks.</p>
              </div>
            </div>
          </div>

          <div className="security-section">
            <h2>Account Security</h2>
            <div className="account-security">
              <div className="account-feature">
                <h3>Strong Password Requirements</h3>
                <p>We enforce strong password policies to help protect your account from unauthorized access.</p>
              </div>
              <div className="account-feature">
                <h3>Two-Factor Authentication</h3>
                <p>Enable two-factor authentication for an additional layer of security on your account.</p>
              </div>
              <div className="account-feature">
                <h3>Session Management</h3>
                <p>Secure session management ensures your login sessions are properly managed and terminated when needed.</p>
              </div>
            </div>
          </div>

          <div className="security-section">
            <h2>Privacy Protection</h2>
            <div className="privacy-protection">
              <div className="privacy-item">
                <h3>Data Minimization</h3>
                <p>We only collect the data necessary to provide our services and improve your experience.</p>
              </div>
              <div className="privacy-item">
                <h3>User Control</h3>
                <p>You have full control over your personal information and can update or delete it at any time.</p>
              </div>
              <div className="privacy-item">
                <h3>Transparency</h3>
                <p>We are transparent about how we collect, use, and protect your personal information.</p>
              </div>
            </div>
          </div>

          <div className="security-section">
            <h2>Reporting Security Issues</h2>
            <div className="security-reporting">
              <p>If you discover a security vulnerability or have concerns about our security practices, please contact our security team immediately:</p>
              <div className="reporting-info">
                <div className="reporting-method">
                  <h3>Security Email</h3>
                  <p>security@inifiy.com</p>
                  <span>For security vulnerabilities and concerns</span>
                </div>
                <div className="reporting-method">
                  <h3>Bug Bounty Program</h3>
                  <p>We offer rewards for responsible disclosure of security vulnerabilities</p>
                  <span>Contact us for program details</span>
                </div>
              </div>
            </div>
          </div>

          <div className="security-section">
            <h2>Security Best Practices</h2>
            <div className="best-practices">
              <div className="practice-item">
                <h3>For Customers</h3>
                <ul>
                  <li>Use strong, unique passwords</li>
                  <li>Enable two-factor authentication</li>
                  <li>Keep your software updated</li>
                  <li>Be cautious of phishing attempts</li>
                  <li>Monitor your account activity</li>
                </ul>
              </div>
              <div className="practice-item">
                <h3>For Our Team</h3>
                <ul>
                  <li>Regular security training</li>
                  <li>Strict access controls</li>
                  <li>Regular security assessments</li>
                  <li>Incident response procedures</li>
                  <li>Continuous monitoring</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="security-section">
            <h2>Contact Our Security Team</h2>
            <p>For security-related questions or concerns, please contact our dedicated security team:</p>
            <div className="contact-info">
                      <p><strong>Security Email:</strong> security@inifiy.com</p>
        <p><strong>General Support:</strong> support@inifiy.com</p>
              <p><strong>Address:</strong> 123 E-commerce Street, Digital City, DC 12345</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security; 